import BadgesValueV2 from "../BadgesValueV2";
import GameBadgeRequirements from "./GameBadgeRequirements";

export default class GameBadgesValue extends BadgesValueV2 {
  public requirements: GameBadgeRequirements = new GameBadgeRequirements();
}
